import React from "react";
import fileImage from "../../_images/files.png";
import FileBox from "./FileBox";
import { jwtDecode } from 'jwt-decode';

function OldFileBox(props) {

    function checkPrintable() {
        const url = new URL(props.link)
        const token = url.searchParams.get("token")
        const decodedToken = jwtDecode(token);
        const contentType = decodedToken.content_type;
        return contentType && contentType.startsWith('image/');
    }

    function getImage() {
        const source = checkPrintable() ? props.link : fileImage
        return <img src={source} alt="" style={{height: "150px", width: "150px"}}/>
    }

    function getFileElement() {
        const url = new URL(props.link)
        const token = url.searchParams.get("token")
        const decodedToken = jwtDecode(token);
        const fileName = decodedToken.fileName;
        return (
            <a href={props.link} target="_blank" rel="noreferrer"
               style={{marginRight: "10px"}}>{fileName}</a>
        )
    }

    return (
        <FileBox getImage={getImage}
                 getFileElement={getFileElement}
                 checkPrintable={checkPrintable}
                 ndx={props.ndx}
                 delete={props.delete}
                 editImage={props.editImage}
                 allowDelete={true}
                 print={props.print}
                 name={`Prilohy.${props.ndx}.Tlacit`}
                 onChange={props.onChange}
        />
    )
}

export default OldFileBox
